import React from 'react';

import Button from 'components/Button';
import Avatar from 'components/Avatar';

import './styles.css';

const TenantInfo = ({
  agreementUser,
  affordabilityId,
  openAffordabilityDocumentUploadModal,
  openAddEmploymentModal
}) => {
  return (
    <div className="TenantInfo">
      <div className="userInfo">
        <Avatar
          className="avatar"
          url={
            agreementUser.internalAvatarCropped || agreementUser.avatarCropped
          }
          initials={agreementUser.initials}
        />
        <div className="text">
          <h5 className="name">{agreementUser.fullName}</h5>
        </div>
      </div>
      <div className="buttons">
        <div className="addEmployment">
          <Button
            white
            onClick={() =>
              openAddEmploymentModal(agreementUser.id, affordabilityId)
            }>
            Add Employment
          </Button>
        </div>
        <div className="uploadDocument">
          <Button
            blue
            onClick={() =>
              openAffordabilityDocumentUploadModal(
                agreementUser.id,
                affordabilityId
              )
            }>
            Upload Document
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TenantInfo;
